import { render, staticRenderFns } from "./takingsPage.vue?vue&type=template&id=0548244a&"
import script from "./takingsPage.vue?vue&type=script&lang=ts&"
export * from "./takingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports